import { render, staticRenderFns } from "./Crowdloan.vue?vue&type=template&id=27f93fda&scoped=true&"
import script from "./Crowdloan.vue?vue&type=script&lang=js&"
export * from "./Crowdloan.vue?vue&type=script&lang=js&"
import style0 from "./Crowdloan.vue?vue&type=style&index=0&id=27f93fda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f93fda",
  null
  
)

export default component.exports